var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Action = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _spraypaint = require("spraypaint");
var _ApplicationRecord2 = require("./ApplicationRecord");
var _ChecklistItem = require("./ChecklistItem");
var _Commitment = require("./Commitment");
var _PersonalChecklistItem = require("./PersonalChecklistItem");
var _Impact = require("./Impact");
var _ActionTheme = require("./ActionTheme");
var _ActionGoal = require("./ActionGoal");
var _ActionInformationItem = require("./ActionInformationItem");
var _ActionResource = require("./ActionResource");
var _ActionFact = require("./ActionFact");
var _ActionBenefit = require("./ActionBenefit");
var _ActionTip = require("./ActionTip");
var _Ease = require("./Ease");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _class3;
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var Action = exports.Action = (_dec = (0, _spraypaint.Model)(), _dec2 = (0, _spraypaint.Attr)({
  persist: false
}), _dec3 = (0, _spraypaint.Attr)({
  persist: false
}), _dec4 = (0, _spraypaint.Attr)({
  persist: false
}), _dec5 = (0, _spraypaint.Attr)({
  persist: false
}), _dec6 = (0, _spraypaint.Attr)({
  persist: false
}), _dec7 = (0, _spraypaint.Attr)({
  persist: false
}), _dec8 = (0, _spraypaint.Attr)({
  persist: false
}), _dec9 = (0, _spraypaint.Attr)({
  persist: false
}), _dec10 = (0, _spraypaint.Attr)({
  persist: false
}), _dec11 = (0, _spraypaint.Attr)({
  persist: false
}), _dec12 = (0, _spraypaint.Attr)({
  persist: false
}), _dec13 = (0, _spraypaint.Attr)({
  persist: false
}), _dec14 = (0, _spraypaint.Attr)({
  persist: false
}), _dec15 = (0, _spraypaint.Attr)({
  persist: false
}), _dec16 = (0, _spraypaint.Attr)({
  persist: false
}), _dec17 = (0, _spraypaint.HasOne)(_Impact.Impact), _dec18 = (0, _spraypaint.HasOne)(_Ease.Ease), _dec19 = (0, _spraypaint.HasOne)(_Commitment.Commitment), _dec20 = (0, _spraypaint.HasMany)(_ActionTheme.ActionTheme), _dec21 = (0, _spraypaint.HasMany)(_ActionGoal.ActionGoal), _dec22 = (0, _spraypaint.HasMany)(_PersonalChecklistItem.PersonalChecklistItem), _dec23 = (0, _spraypaint.HasMany)(_ChecklistItem.ChecklistItem), _dec24 = (0, _spraypaint.HasMany)(_ActionInformationItem.ActionInformationItem), _dec25 = (0, _spraypaint.HasMany)(_ActionResource.ActionResource), _dec26 = (0, _spraypaint.HasMany)(_ActionFact.ActionFact), _dec27 = (0, _spraypaint.HasMany)(_ActionBenefit.ActionBenefit), _dec28 = (0, _spraypaint.HasMany)(_ActionTip.ActionTip), _dec(_class = (_class2 = (_class3 = function (_ApplicationRecord) {
  (0, _inherits2["default"])(Action, _ApplicationRecord);
  var _super = _createSuper(Action);
  function Action() {
    var _this;
    (0, _classCallCheck2["default"])(this, Action);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "name", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "description", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "param", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "promise", _descriptor4, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "summary", _descriptor5, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "section", _descriptor6, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "completionCriterion", _descriptor7, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "improvements", _descriptor8, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slug", _descriptor9, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "tags", _descriptor10, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "footprintParam", _descriptor11, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "popularity", _descriptor12, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "interactive", _descriptor13, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isHighlighted", _descriptor14, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "workStep", _descriptor15, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "impact", _descriptor16, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ease", _descriptor17, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "commitment", _descriptor18, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "themes", _descriptor19, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goals", _descriptor20, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "personalChecklistItems", _descriptor21, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checklistItems", _descriptor22, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "informationItems", _descriptor23, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resources", _descriptor24, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "facts", _descriptor25, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "benefits", _descriptor26, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "tips", _descriptor27, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  return (0, _createClass2["default"])(Action);
}(_ApplicationRecord2.ApplicationRecord), (0, _defineProperty2["default"])(_class3, "jsonapiType", 'actions'), _class3), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "description", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "param", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "promise", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "summary", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "section", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "completionCriterion", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "improvements", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "slug", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "tags", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "footprintParam", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "popularity", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "interactive", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "isHighlighted", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "workStep", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "impact", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "ease", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "commitment", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "themes", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "goals", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "personalChecklistItems", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "checklistItems", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "informationItems", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "resources", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "facts", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "benefits", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "tips", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);